import { WidgetKind, type WidgetOf } from 'corso-admin-ui';
import { rateReport } from '../orderItems';

export const itemReturnRate = {
  kind: WidgetKind.kpi,
  description: 'Of items ordered in this period, returned so far',
  metric: 'returnRate',
} as const satisfies WidgetOf<'orderItems'>;

export const rate = rateReport({
  finalized: { metric: 'returnItemsFinalized', title: 'Items returned' },
  rate: itemReturnRate,
  chart: {
    title: 'Return rate by order date',
    description:
      'By when the items were ordered; recent orders read low until their returns come in',
  },
  tables: {
    products: 'Product return rate',
    variants: 'Product variant return rate',
    rankedBy: 'items returned',
  },
});
